import { useViewportSize } from "@react-aria/utils";
import { max, min } from "d3-array";
import * as React from "react";

export function ZoomForeignObject({ children, width, height, x, y, onZoom }) {
  const viewportSize = useViewportSize();

  return (
    <foreignObject
      height={height}
      width={width}
      x={x}
      y={y}
      onClick={(e) => {
        const kW = viewportSize.width / (width + 1);
        const kH = viewportSize.height / (height + 75);

        // console.log({ kW, kH });

        onZoom(e, {
          x: x + width / 2,
          y: y + height / 2,
          k: max([kW, kH]),
        });
      }}
    >
      {children}
    </foreignObject>
  );
}
